import React, { useState } from 'react';
import Edit from "../components/Edit";
import CompetitorList from '../components/CompetitorList';
import { useAdmin } from '../auth/AdminContext';
import { updateContent } from '../services/api';

const Paasarja = ({ title, onTitleUpdate }) => {
  const [info, setInfo] = useState("");
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [newTitle, setNewTitle] = useState(title);
  const { isAdmin, token } = useAdmin();

  const handleTitleSave = () => {
    updateContent('title_paasarja', newTitle, token)
      .then(() => {
        onTitleUpdate(newTitle);
        setIsEditingTitle(false);
      })
      .catch(() => {});
  };

  return (
    <div>
      <Edit
        title={`${title} - Info`}
        contentKey="paasarja_info"
        value={info}
        onChange={setInfo}
      />
      <h1>
        {isEditingTitle ? (
          <input
            type="text"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
          />
        ) : (
          `${title} - Tulokset`
        )}
        {isAdmin && !isEditingTitle && (
          <button onClick={() => { setNewTitle(title); setIsEditingTitle(true); }}>Muokkaa otsikkoa</button>
        )}
        {isAdmin && isEditingTitle && (
          <>
            <button onClick={handleTitleSave}>Tallenna</button>
            <button onClick={() => setIsEditingTitle(false)}>Peruuta</button>
          </>
        )}
      </h1>
      <CompetitorList category="paasarja" />
    </div>
  );
};

export default Paasarja;